import { createUseStyles } from 'react-jss';
import { colorsModeUI } from '../../modeUI';

export default createUseStyles(
  (theme: ReturnType<typeof colorsModeUI>) => ({
    container: {
      '&& .ui.divided.list>.item': { borderColor: theme.INPUT_BORDER_COLOR },
      '&& .ui.divider:not(.vertical):not(.horizontal)': {
        borderTopColor: theme.INPUT_BORDER_COLOR,
      },
    },
    containerConfirm: {
      marginTop: '1em',
      textAlign: 'right',
    },
  }),
  { name: 'SelectMultiple' }
);
